import type {ComponentProps} from "react";
import {Circle, Group, Text} from "react-konva";
import type {Annotation} from "@/dungeons/model/DungeonGeometry.ts";
import {annotationAppearance} from "./AnnotationAppearance.ts";

type GroupEvents = Pick<ComponentProps<typeof Group>, "onClick" | "onTap" | "onMouseDown" | "onDragStart" | "onDragEnd">;

export default function AnnotationMarker({annotation, x, y, zoom, selected, draggable, ...events}: {
    annotation: Annotation;
    x: number;
    y: number;
    zoom: number;
    selected: boolean;
    draggable: boolean;
    listening?: boolean;
} & GroupEvents) {
    const {color, label} = annotationAppearance(annotation);
    return <Group x={x} y={y} draggable={draggable} {...events}>
        <Circle radius={17 / zoom} fill={color} stroke={selected ? "#fff" : "#111827"}
                strokeWidth={(selected ? 3 : 2) / zoom}/>
        <Text x={-15 / zoom} y={-6 / zoom} width={30 / zoom} height={12 / zoom}
              text={label} align="center" fill="white" fontStyle="bold" fontSize={12 / zoom}
              listening={false}/>
    </Group>;
}
